import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation(); // الحصول على الموقع الحالي

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
       
        // تنظيف event listener عند unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleDarkMode = () => {
        const theme = document.documentElement.getAttribute('data-bs-theme');
        const newTheme = theme === 'dark' ? 'light' : 'dark';
       
        document.documentElement.setAttribute('data-bs-theme', newTheme);
       
        // تحديث الأيقونات
        const darkIcons = document.querySelectorAll('.dark-mode-only');
        const lightIcons = document.querySelectorAll('.light-mode-only');
       
        if (newTheme === 'dark') {
            darkIcons.forEach(icon => icon.classList.remove('d-none'));
            lightIcons.forEach(icon => icon.classList.add('d-none'));
        } else {
            darkIcons.forEach(icon => icon.classList.add('d-none'));
            lightIcons.forEach(icon => icon.classList.remove('d-none'));
        }
    };

    const isHomePage = location.pathname === '/'; // التحقق إذا كنت في الصفحة الرئيسية

    return (
        <nav className={`navbar navbar-expand-lg sticky-top ${scrolled ? 'navbar-scrolled shadow-sm' : ''}`}>
            <div className="container">
                {isHomePage ? (
                    <a className="navbar-brand fw-bold fs-4" href="#home">
                        <span>العيزري </span><span className="text-primary">للحلول البرمجية </span>
                    </a>
                ):(
                    <Link className="navbar-brand fw-bold fs-4" to="/" state={{scrollTo:'hero'}}>
                        <span>العيزري </span><span className="text-primary">للحلول البرمجية </span>
                    </Link>
                )}
               
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            {isHomePage ? (
                                <a className="nav-link" href="#hero">الرئيسية</a>
                            ):(
                                <Link className='nav-link' to="/" state={{scrollTo:'hero'}}>الرئيسية</Link> 
                            )}
                        </li>
                        <li className="nav-item">
                            {isHomePage ? (
                                <a className="nav-link" href="#about">عني</a>
                            ):(
                                <Link className='nav-link' to="/" state={{scrollTo:'about'}}>عني</Link> 
                            )}
                        </li>
                        <li className="nav-item">
                            {isHomePage ? (
                                <a className="nav-link" href="#skills">المهارات</a>
                            ):(
                                <Link className='nav-link' to="/" state={{scrollTo:'skills'}}>المهارات</Link> 
                            )}
                        </li>
                        <li className="nav-item">
                        {isHomePage ? (
                                <a className="nav-link" href="#projects">المشاريع</a>
                            ):(
                                <Link className='nav-link' to="/" state={{scrollTo:'projects'}}>المشاريع</Link> 
                            )}
                        </li>
                        <li className="nav-item">
                        {isHomePage ? (
                                <a className="nav-link" href="#contact">اتصل بي</a>
                            ):(
                                <Link className='nav-link' to="/" state={{scrollTo:'contact'}}>اتصل بي</Link> 
                            )}
                        </li>
                    </ul>
                    <button onClick={toggleDarkMode} className="btn btn-sm btn-outline-secondary rounded-circle ms-2 p-2">
                        <i className="fa-solid fa-moon dark-mode-only"></i>
                        <i className="fa-solid fa-sun light-mode-only"></i>
                    </button>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;